const WELCOME_MODAL_SEEN_KEY = "aws-welcome-modal-seen";

interface BootstrapModalInstance {
	show(): void;
}

interface BootstrapModalConstructor {
	new (element: Element): BootstrapModalInstance;
}

interface BootstrapApi {
	Modal: BootstrapModalConstructor;
}

export function showWelcomeModalIfNeeded(bootstrapApi?: BootstrapApi): void {
	const modalElement = document.getElementById("welcomeModal");
	if (!modalElement) return;

	if (window.localStorage.getItem(WELCOME_MODAL_SEEN_KEY) === "true") {
		return;
	}

	if (!bootstrapApi?.Modal) {
		return;
	}

	window.localStorage.setItem(WELCOME_MODAL_SEEN_KEY, "true");
	const modal = new bootstrapApi.Modal(modalElement);
	modal.show();
}
